//********* SQFT *********//
import * as types from "./actionTypes";

export const enableSquareFootage = (isSquareFootageEnabled) => ({
  type: types.ENABLE_SQUARE_FOOTAGE,
  payload: {isSquareFootageEnabled}
});

export const setSquareFootageGroup = (SQFTGroup) => ({
  type: types.SET_SQUARE_FOOTAGE_GROUP,
  payload: {SQFTGroup}
});

export const setSQFTGroup = (SQFTGroup) => ({
  type: types.SET_SQUARE_FOOTAGE_GROUP,
  payload: {SQFTGroup}
});

export const setSQFTViewMode = (SQFTViewMode) => ({
  type: types.SET_SQFT_VIEW_MODE,
  payload: {SQFTViewMode}
});

export const loadSQFT = () => ({
  type: types.LOAD_SQFT,
  payload: {sqftLoaded: true}
});

export const updateSQFT = (sqftUpdateType) => ({
  type: types.UPDATE_SQFT,
  payload: {sqftUpdateType}
});

export const updateSQFTCalculations = (updateCalculations) => ({
  type: types.UPDATE_SQFT_CALCULATIONS,
  payload: {updateCalculations}
});

export const setSquareFeet = (squareFeet) => ({
  type: types.SET_SQFT_SQUARE_FEET,
  payload: {squareFeet}
});

export const toggleChangeLayoutPopup = (changeLayoutPopupOpened = false, layoutToApply = "", applyLayoutOnSqft = false) => ({
  type: types.TOGGLE_CHANGE_LAYOUT_POPUP,
  payload: {changeLayoutPopupOpened, layoutToApply, applyLayoutOnSqft}
});

export const sendLayoutChangeOnSqft = (setNewLayoutOnSqft) => ({
  type: types.SET_NEW_LAYOUT_ON_SQFT,
  payload: {setNewLayoutOnSqft}
});

export const setSqftMeasureUnit = (measureUnit) => ({
  type: types.SET_SQFT_MEASURE_UNIT,
  payload: {measureUnit}
});

export const changeSqftFeaturesPopup = (sqftFeaturesPopup) => ({
  type: types.CHANGE_SQFT_FEATURES_POPUP,
  payload: {sqftFeaturesPopup}
});

export const setSqftFromFeature = (sqftFromFeature) => ({
  type: types.SQT_SQFT_FROM_FEATURE,
  payload: {sqftFromFeature}
});

export const setSqftCabinetsGlb = (cabinetsGlb) => ({
  type: types.SET_CABINETS_GLB,
  payload: {cabinetsGlb}
});

export const setCabinetsARBlobUrl = (cabinetsARBlobUrl) => ({
  type: types.SET_CABINETS_AR_BLOB_URL,
  payload: {cabinetsARBlobUrl}
});

export const setAPIErrorMessage = (apiErrorMessage) => ({
  type: types.SET_API_ERROR_MESSAGE,
  payload: {apiErrorMessage}
});

export const setSQFTInVisualizer = (isSQFTInVisualizer) => ({
  type: types.SET_SQFT_IN_VISUALIZER,
  payload: {isSQFTInVisualizer}
});
